import React, { Component } from 'react'
import queryString from 'query-string'
import { Route } from 'react-router-dom'
import { observer, inject, Provider } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import pick from 'lodash/pick'
import debounce from 'lodash/debounce'

import ClientView from './ClientView'
import EmailTracking from './EmailTracking'
import Details from './Details'
import ExpertsPipeline from './ExpertsPipeline'
import ExtractEpls from './ExtractEpls'
import Fee from './Fee'
import Invoice from '@root/Invoice'
import Outcome from './Outcome'
import EplEmails from './EplEmails'
import Correspondence from './Correspondence'
import MobileCorrespondence from './Correspondence/MobileCorrespondence'
import Header from './Components/Header'
import Scroll from '@components/Scroll'
import Spinner from '@components/spinner'
import Logs from '@components/Logs'
import Tabs from '@components/Tabs'
import MobileHeader from './Components/MobileHeader'
import MobileTabs from './Components/MobileTabs'

import ExtractEplStore from './stores/extractEpl.store'
import FeeStore from './stores/fee.store'
import ProjectStore from './stores/project.store'
import EplEmailStore from './stores/eplEmail.store'
import SegmentStore from './stores/segment.store'
import SurveyView from './SurveyView/SurveyView'

class ProjectPage extends Component {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    commentStore: PropTypes.object,
    modalStore: PropTypes.object,
    userStore: PropTypes.object,
    ruleStore: PropTypes.object,
    eplStore: PropTypes.object,
    activeProjectStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    const {
      staticData,
      growlStore,
      modalStore,
      userStore,
      ruleStore,
      activeProjectStore
    } = props
    const segmentStore = new SegmentStore(growlStore)
    const projectStore = new ProjectStore(
      staticData,
      segmentStore,
      growlStore,
      modalStore,
      userStore,
      activeProjectStore
    )
    const extractEplStore = new ExtractEplStore(
      projectStore,
      staticData,
      userStore
    )
    const feeStore = new FeeStore(
      staticData,
      modalStore,
      growlStore,
      ruleStore,
      projectStore
    )
    const eplEmailStore = new EplEmailStore(growlStore)
    extendObservable(this, {
      projectStore,
      segmentStore,
      extractEplStore,
      feeStore,
      eplEmailStore
    })
    this.loadProject()
  }

  state = { size: window.screen.width }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate() {
    this.loadProject()
  }

  handleResize = () => {
    this.setState({ size: window.screen.width })
  }

  loadProject() {
    const projectId = this.props.match.params.id
    if (this.projectStore.id === Number(projectId)) return
    this.props.eplStore.isExpertQuickSearchActive = false
    this.props.eplStore.expertQuickSearchValue = ''
    this.projectStore.get(projectId)
  }

  render() {
    const { staticData, match, location } = this.props
    const { projectStore } = this
    const { INVOICE_TYPES, PROJECT_TYPES } = staticData.CONST
    let projectTabs = tabs
    if(!projectStore.capiDetails){
      projectTabs = projectTabs.filter((e) => e.tab !== 'correspondence')
    }
    if (projectStore.project) {
      if (
        projectStore.project.projectTypeId !==
        PROJECT_TYPES.EXPERT_SURVEY_RESEARCH
      ) {
        projectTabs = projectTabs.filter(e => e.tab !== 'survey')
      }
    }

    const params = queryString.parse(location.search)

    if (projectStore.loading) {
      return <Spinner />
    }

    return (
      <Provider
        {...pick(this, [
          'projectStore',
          'segmentStore',
          'extractEplStore',
          'feeStore',
          'eplEmailStore'
        ])}>
        <div className="expert-search-results">
          <Scroll
            isVisible
            onScroll={debounce(
              val => {
                this.props.eplStore.setVisible(val)
              },
              100,
              { maxWait: 250 }
            )}>
            <div
              className="project-wrapper"
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: 0
              }}>
              {this.state.size < 1280 &&
                location.pathname.includes('correspondence') ? (
                <>
                  <MobileHeader projectStore={projectStore} />
                  <div className="mobile-expert-tabs">
                    <MobileTabs
                      ignoreExactMatches={['experts-pipeline', 'invoice']}
                      matchId={match.params.id}
                      matchUrl={location.pathname}
                      match={match}
                      tabs={projectTabs}
                    />
                  </div>
                </>
              ) : (
                <>
                  <Header projectStore={projectStore} />
                  <div className="expert-tabs">
                    <Tabs
                      ignoreExactMatches={['experts-pipeline', 'invoice']}
                      matchId={match.params.id}
                      matchUrl={location.pathname}
                      match={match}
                      tabs={projectTabs}
                    />
                  </div>
                </>
              )}

              {!projectStore.loading && (
                <div className="views-wrapper" style={{ flex: 1 }}>
                  <Route exact path={match.url} component={Details} />
                  <Route
                    exact
                    path={match.url + '/experts-pipeline'}
                    component={ExpertsPipeline}
                  />
                  {projectStore?.project?.projectTypeId ===
                    PROJECT_TYPES.EXPERT_SURVEY_RESEARCH && (
                    <Route
                      exact
                      path={match.url + '/survey'}
                      component={SurveyView}
                    />
                  )}

                  {projectStore.capiDetails && (
                    <Route
                      exact
                      path={match.url + '/correspondence'}
                      render={props => {
                        return this.state.size < 1280 &&
                          location.pathname.includes('correspondence') ? (
                          <MobileCorrespondence
                            id={match.params.id}
                            c={params.id}
                          />
                        ) : (
                          <Correspondence />
                        )
                      }}
                    />
                  )}
                  <Route
                    exact
                    path={match.url + '/experts-pipeline/:eplId'}
                    component={ExpertsPipeline}
                  />
                  <Route
                    exact
                    path={match.url + '/extract-epls'}
                    component={ExtractEpls}
                  />
                  <Route
                    exact
                    path={match.url + '/client-view'}
                    component={ClientView}
                  />
                  <Route
                    exact
                    path={match.url + '/outcome'}
                    component={Outcome}
                  />
                  <Route path={match.url + '/fee/:feeId'} component={Fee} />
                  <Route
                    path={match.url + '/invoice'}
                    render={props => (
                      <Invoice
                        {...props}
                        invoiceType={INVOICE_TYPES.PAYG}
                        project={projectStore.project}
                      />
                    )}
                  />
                  <Route
                    path={match.url + '/email-tracking'}
                    component={EmailTracking}
                  />
                  <Route
                    path={match.url + '/epl-emails/:eplId'}
                    component={EplEmails}
                  />
                  <Route
                    path={match.url + '/logs'}
                    render={props => (
                      <Logs
                        {...props}
                        type="project"
                        itemId={projectStore.project.id}
                      />
                    )}
                  />
                </div>
              )}
            </div>
          </Scroll>
        </div>
      </Provider>
    )
  }
}

const tabs = [
  {
    tab: 'details'
  },
  {
    tab: 'experts-pipeline'
  },
  {
    tab: 'correspondence'
  },
  {
    tab: 'survey'
  },
  {
    tab: 'client-view'
  },
  {
    tab: 'outcome',
    roles: [
      'FeeManagement',
      'Accounting',
      'AdvancedExpertManagement',
      'ProjectManagement',
      'AdvancedReporting',
      'Admin'
    ]
  },
  {
    tab: 'invoice',
    roles: [
      'FeeManagement',
      'Accounting',
      'AdvancedExpertManagement',
      'ProjectManagement',
      'AdvancedReporting',
      'Admin'
    ]
  },
  {
    tab: 'email-tracking'
  },
  {
    tab: 'logs'
  }
]

export default inject(
  'staticData',
  'growlStore',
  'modalStore',
  'userStore',
  'ruleStore',
  'eplStore',
  'activeProjectStore'
)(observer(ProjectPage))
